import type { CoachingVisibility } from "@/lib/types";

export function playerAudienceLabel(playerIds: string[] | undefined): string {
  const count = playerIds?.length ?? 0;
  if (count === 0) return "For: team";
  return `For: ${count} player${count === 1 ? "" : "s"}`;
}

export function visibilityLabel(
  visibility: CoachingVisibility | string,
): string {
  if (visibility === "player") return "Player + family";
  if (visibility === "team") return "Whole team";
  if (visibility === "private") return "Coaches only";
  return visibility;
}

export function linkedEvidenceLabel(input: {
  notes?: number;
  clips?: number;
  playlists?: number;
}): string {
  const parts: string[] = [];
  if (input.notes) {
    parts.push(`${input.notes} note${input.notes === 1 ? "" : "s"}`);
  }
  if (input.clips) {
    parts.push(`${input.clips} clip${input.clips === 1 ? "" : "s"}`);
  }
  if (input.playlists) {
    parts.push(
      `${input.playlists} legacy session${input.playlists === 1 ? "" : "s"}`,
    );
  }
  return parts.length ? `Evidence: ${parts.join(", ")}` : "Evidence: none";
}
